import React from 'react';

const publicationsData = [
  {
  id: 19,
    title: 'Marwaha, D., Sharma, A., Saini, K., Singh, A. K., Bhaskar, A., & Ray, A. (2026). LiMeNEx: an interactive webserver on lipid biochemical gene-regulatory network. Nucleic Acids Research, gkag384.',
    url: 'https://academic.oup.com/nar/advance-article-abstract/doi/10.1093/nar/gkag384/8709442'
  },
  {
    id: 18,
    title: 'Dada, N. Y., Shah, M. Z., Sacher, S., Govindh, M. P., Bhedsurkar, P., Nair, R. R., ... & Kamble, S. S. (2026). Molecular Insights into Anabaenopeptin-Mediated Inhibition of Protein Tyrosine Phosphatase B in the Mycobacterium tuberculosis Complex. ACS omega, 11(14), 21556-21576.',
    url: 'https://pubs.acs.org/doi/abs/10.1021/acsomega.5c01567'
  },
  {
    id: 17,
    title: 'Sacher, S., Singh, P., Mukherjee, A., Bhaskar, A. K., Chakraborty, K., Counillon, L., ... & Ray, A. (2026). Phospholipids that Plug the Pores of Cholesteryl Ester Transfer Protein Control Its Triglyceride Transfer. Computational and Structural Biotechnology Journal, 35(1), 0122.',
    url: 'https://spj.science.org/doi/abs/10.34133/csbj.0122'
  },
    {
    id: 16,
    title: 'Sacher, S., Afroz, S., Kaur, A. and Ray, A. *, 2026. Lipid–protein interactions and molecular dynamics simulation. In Lipid Analysis in Biology, Health, and Disease (pp.23-35). Academic Press.',
    url: 'https://scholar.google.com/scholar?hl=en&as_sdt=0%2C5&q=Sacher%2C+S.%2C+Afroz%2C+S.%2C+Kaur%2C+A.+and+Ray%2C+A.+*%2C+2026.+Lipid%E2%80%93protein+interactions+and+molecular+dynamics+simulation.+In+Lipid+Analysis+in+Biology%2C+Health%2C+and+Disease+%28pp.+23-35%29.+Academic+Press.+https%3A%2F%2Fdoi.org%2F10.1016%2FB978-0-443-19116-9.00021-X.&btnG='
  },
   {
    id: 15,
    title: 'Kaur, A., Saha, S., Ujjainiya, R., Ray, A., Basak, T. and Sengupta, S., 2026. Apolipoproteins and cardiovascular diseases. In Lipid Analysis in Biology, Health, andDisease (pp. 371-406). Academic Press.',
    url: 'https://scholar.google.com/scholar?hl=en&as_sdt=0%2C5&q=Kaur%2C+A.%2C+Saha%2C+S.%2C+Ujjainiya%2C+R.%2C+Ray%2C+A.%2C+Basak%2C+T.+and+Sengupta%2C+S.%2C+2026.+Apolipoproteins+and+cardiovascular+diseases.+In+Lipid+Analysis+in+Biology%2C+Health%2C+and+Disease+%28pp.+371-406%29.+Academic+Press.+https%3A%2F%2Fdoi.org%2F10.1016%2FB978-0-443-19116-+9.00032-4&btnG='
  },
   {
    id: 14,
    title: 'Sarah, S.R., Garg, A., Afroz, S., Korch, S., Ray, A., Gupta, A. and Malhotra, V., 2025.Ser/Thr phosphorylation of Mycobacterium tuberculosis type II RelK toxin by PknKdestabilizes TA interaction and interferes with toxin neutralization. mBio, pp.e01068-25.',
    url: 'https://scholar.google.com/scholar?hl=en&as_sdt=0%2C5&q=Sarah%2C+S.R.%2C+Garg%2C+A.%2C+Afroz%2C+S.%2C+Korch%2C+S.%2C+Ray%2C+A.%2C+Gupta%2C+A.+and+Malhotra%2C+V.%2C+2025.+Ser%2FThr+phosphorylation+of+Mycobacterium+tuberculosis+type+II+RelK+toxin+by+PknK+destabilizes+TA+interaction+and+interferes+with+toxin+neutralization.+mBio%2C+pp.e01068-25.+doi%3A+10.1128%2Fmbio.01068-25.&btnG='
  },
   {
    id: 13,
    title: 'Francis, A.X., Chilkoti, M., Atul, Mrinal, Sacher, S.* and Ray, A.*, 2025. An Algorithm-Based Investigation to Reveal the Differential Dynamics of Water insideProtein Cavities as a Function of Distance from Their Wall. Journal of Chemical Information and Modeling, 65(10), pp.5176-5187.',
    url: 'https://scholar.google.com/scholar?hl=en&as_sdt=0%2C5&q=Francis%2C+A.X.%2C+Chilkoti%2C+M.%2C+Atul%2C+Mrinal%2C+Sacher%2C+S.*+and+Ray%2C+A.*%2C+2025.+An+Algorithm-Based+Investigation+to+Reveal+the+Differential+Dynamics+of+Water+inside+Protein+Cavities+as+a+Function+of+Distance+from+Their+Wall.+Journal+of+Chemical+Information+and+Modeling%2C+65%2810%29%2C+pp.5176-5187.+doi%3A+10.1021%2Facs.jcim.5c00448.&btnG='
  },
  {
    id: 12,
    title: 'Rakheja, I., Panda, G., Maiti, S. and Ray, A.*, 2025. Molecular Modeling of Non-Canonical Intramolecular RNA Triple Helix Structures Predicted from TRIPinRNA andTheir In Vitro Biophysical Structure Validation. The Journal of Physical Chemistry B,129(18), pp.4298-4308.',
    url: 'https://scholar.google.com/scholar?hl=en&as_sdt=0%2C5&q=Rakheja%2C+I.%2C+Panda%2C+G.%2C+Maiti%2C+S.+and+Ray%2C+A.*%2C+2025.+Molecular+Modeling+of+Non-+Canonical+Intramolecular+RNA+Triple+Helix+Structures+Predicted+from+TRIPinRNA+and+Their+In+Vitro+Biophysical+Structure+Validation.+The+Journal+of+Physical+Chemistry+B%2C+129%2818%29%2C+pp.4298-4308.+doi%3A+10.1021%2Facs.jpcb.5c00160.%28IF%3A3.5%29&btnG='
  },
  {
    id: 11,
    title: 'Panda, Gayatri, Arjun Ray. "Deciphering Cas9 specificity: Role of domain dynamics and RNA: DNA hybrid interactions revealed through machine learning and accelerated molecular simulations" International Journal of Biological Macromolecules, 2024•Elsevier',
    url: 'https://scholar.google.com/scholar?hl=en&as_sdt=0%2C5&q=Deciphering+Cas9+specificity%3A+Role+of+domain+dynamics+and+RNA%3ADNA+hybrid+interactions+revealed+through+machine+learning+and+accelerated+molecular+simulations&btnG='
  },
  {
    id: 10,
    title: 'Sacher, Sukriti, Arjun Ray. "In Silico Strategies for Characterizing Inner Cavities of Lipid-Binding Proteins" Intracellular Lipid Transport: Methods and Protocols, 2024•Springer',
    url: 'https://scholar.google.com/scholar?hl=en&as_sdt=0%2C5&q=In+Silico+Strategies+for+Characterizing+Inner+Cavities+of+Lipid-Binding+Proteins&btnG=',
  },
  {
    id: 1,
    title: 'Sacher, Sukriti, Abhishek Mukherjee, and Arjun Ray. "Deciphering structural aspects of reverse cholesterol transport: mapping the knowns and unknowns." Biological Reviews 98.4 (2023): 1160-1183.',
    url: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:gVv57TyPmFsC',
  },
  {
    id: 2,
    title: 'gautam, prutyay, et al. "DIGEST: An online tool for designing of multiple reaction monitoring assays." bioRxiv (2023): 2023-11.',
    url: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:Ak0FvsSvgGUC',
  },
  {
    id: 3,
    title: 'Panda, Gayatri, and Arjun Ray. "Decrypting the mechanistic basis of CRISPR/Cas9 protein." Progress in Biophysics and Molecular Biology 172 (2022): 60-76.',
    url: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:u-coK7KVo8oC',
  },
  {
    id: 4,
    title: 'Garg, Parth, et al. "CICLOP: a robust and accurate computational framework for protein inner cavity detection." Bioinformatics 38.8 (2022): 2153-2161.',
    url: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:8xutWZnSdmoC',
  },
  {
    id: 5,
    title: 'Panda, Gayatri, and Arjun Ray. "Comparative structural and dynamics study of free and gRNA-bound FnCas9 and SpCas9 proteins." Computational and Structural Biotechnology Journal 20 (2022): 4172-4184.',
    url: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:5MTHONV0fEkC',
  },
  {
    id: 6,
    title: 'Sacher, Sukriti, and Arjun Ray. "Solvation Dynamics of a Single Triglyceride as a Function of its Chain Length." bioRxiv (2022): 2022-03.',
    url: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:GFxP56DSvIMC',
  },
  {
    id: 7,
    title: 'Panda, Gayatri, Neha Mishra, and Arjun Ray. "Genetic variations and drug repurposing provides key insights into the disruption of the SARS COV2." (2020).',
    url: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:GFxP56DSvIMC',
  },
  {
    id: 8,
    title: 'Sunidhi, S., et al. "Elucidating the structural features of ABCA1 in its heterogeneous membrane environment." Frontiers in Molecular Biosciences 8 (2022): 803078.',
    url: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:LhH-TYMQEocC',
  },
  {
    id: 9,
    title: 'Comprehensive assessment of Indian variations in the druggable kinome landscape highlights distinct insights at the sequence, structure and pharmacogenomic stratum',
    url: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=reRjZdUAAAAJ&cstart=20&pagesize=80&sortby=pubdate&citation_for_view=reRjZdUAAAAJ:a3BOlSfXSfwC',
  },
];

const Publications = () => {
  return (
    <section id='publications' className='max-w-screen-xl mx-auto w-full h-fit pb-20 py-20 text-lightText flex flex-col border-b-[1px] border-b-black'>
      <div className='flex flex-col gap-8 font-titleFont'>
        <h1 className='text-5xl font-bold text-designColor text-center mb-8'>Publications</h1>
        {publicationsData.map(publication => (
          <a key={publication.id} href={publication.url || '#'} target='_blank' rel='noopener noreferrer'>
            <div className='pb-5 pl-2 pt-8 pr-6 bg-bodyColor outline outline-offset-2 outline-designColor rounded-lg w-full max-w-[1240px] min-h-[100px] h-auto text-bodyColor hover:shadow-lg transition duration-300 ease-in-out hover:scale-105'>
              <div className='pl-6 pb-12 flex flex-col'>
                <h2 className='text-xl text-lightText font-semibold'>{publication.title}</h2>
              </div>
            </div>
          </a>
        ))}
        <div className='mt-8 flex justify-center'>
          <a href='/all-publications' className='px-8 py-4 bg-designColor text-white text-2xl font-extrabold rounded-lg hover:shadow-lg transition duration-300 ease-in-out hover:scale-105'>
            More Publications
          </a>
        </div>
      </div>
    </section>
  );
}

export default Publications;

